
function ButtonComp({
  title,
  classnameIcon,
  buttonColor,
  onClick,
  hoverMessage,
  type,
  disabled,
  style
}) {
  return (
    <div className="row">
      <div className="d-flex justify-content-end">
        <button
          title={hoverMessage}
          type={type}
          className="btn btn-sm btn-standard-height d-flex align-items-center justify-content-center"
          onClick={onClick}
          style={{
            backgroundColor: buttonColor,
            color: 'white',
            border: `1px solid ${buttonColor}`,
            padding: '0.625rem 1.25rem',
            fontSize: '0.875rem',
            fontWeight: 'bold',
            textAlign: 'center',
            transition: 'filter 0.3s ease',
            ...style
          }}
          onMouseEnter={e => {
            e.target.style.filter = 'brightness(90%)';
          }}
          onMouseLeave={e => {
            e.target.style.filter = 'brightness(100%)';
          }}
          // Remova o title aqui, pois Tooltip já cobre!
          disabled={disabled}
        >
          <i className={classnameIcon} style={{ marginRight: '0.5rem' }}></i>
          {title}
        </button>
      </div>
    </div>
  );
}

export default ButtonComp;
